var map = {
	"./东吴人寿.png": "yFSJ",
	"./中信保诚.png": "2WQ5",
	"./中信宝诚.png": "2G2Q",
	"./中南大学湘雅医院.png": "EiMk",
	"./中国人保财险.png": "mppS",
	"./中国人寿.png": "FLvn",
	"./中国太平.png": "eE6J",
	"./中国平安.png": "XVgu",
	"./中山大学附属第一医院.png": "DPGl",
	"./九州通健康科技集团.png": "I3RN",
	"./众安保险 .png": "58OI",
	"./众安保险.png": "6fEJ",
	"./华农保险.png": "DPwt",
	"./华西医院.png": "BklV",
	"./四川大学华西医院.png": "r0yd",
	"./四川省人民医院.png": "C6iO",
	"./国任保险.png": "WU67",
	"./圆心惠宝.png": "YS6m",
	"./复旦大学附属华东医院.png": "8eP1",
	"./太平洋保险.png": "UXRI",
	"./安诚保险.png": "RLjl",
	"./富德生命人寿.png": "E0wf",
	"./开普云.png": "a7un",
	"./成都大学.png": "FmCY",
	"./汇医慧影.png": "BoUv",
	"./江苏省人民医院.png": "2HUm",
	"./泰康.png": "MSay",
	"./浙江大学附属第一医院.png": "jt9G",
	"./海王星辰.png": "fYtX",
	"./深圳市人民医院.png": "1XmF",
	"./深圳市第三人民医院.png": "O2x/",
	"./盛诺一家.png": "bL3f",
	"./罗氏.png": "Dn6I",
	"./西安交通大学第一附属医院.png": "tQ3d",
	"./观合医药.png": "QOGy",
	"./青岛大学附属医院.png": "AvZJ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PrSz";


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/assets/pc/cooperation/outer ^\.\/.*$
// module id = PrSz
// module chunks = 0 1 2 9